var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.6262 0 0 7.6263 0 17.0001C0 26.3739 7.6262 34 17 34C26.3738 34 34 26.3739 34 17.0001C34 7.6263 26.3738 0 17 0ZM17 30.9091C9.33042 30.9091 3.09091 24.6696 3.09091 17.0001C3.09091 9.33063 9.33042 3.09091 17 3.09091C24.6696 3.09091 30.9091 9.33063 30.9091 17.0001C30.9091 24.6696 24.6695 30.9091 17 30.9091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 7.21191C15.8639 7.21191 14.9397 8.13671 14.9397 9.27345C14.9397 10.4092 15.8639 11.3331 16.9999 11.3331C18.1359 11.3331 19.0601 10.4092 19.0601 9.27345C19.0601 8.13671 18.1359 7.21191 16.9999 7.21191Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.4243C16.1465 14.4243 15.4546 15.1163 15.4546 15.9698V25.2425C15.4546 26.096 16.1465 26.788 17 26.788C17.8535 26.788 18.5455 26.096 18.5455 25.2425V15.9698C18.5455 15.1163 17.8535 14.4243 17 14.4243Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoExclamation);
export default __webpack_public_path__ + "static/media/info_exclamation.a52df6b5e993c6f8d8f46519ff0d93d5.svg";
export { ForwardRef as ReactComponent };